import SwivuTabBase from "../base/SwivuTabBase.jsx";

export default class ResourceEditTabBase extends SwivuTabBase {
  static get $name() {
    return "ResourceEditTabBase";
  }

  // Factoryable type name
  static get type() {
    return "resourceedittabbaseV2";
  }

  static get configurable() {
    return {
      autoUpdateRecord: true
    };
  }

  editRecord(record, context, otherParams) {
    this.loaded = false;
    this.loadRecord(record, context, otherParams);
    this.loaded = true;
  }

  loadRecord(record, context, otherParams) {
    this.record = record;
    this.otherParams = otherParams;
    Object.assign(this, context);
    this.swivuCheckGrants(context.user);
  }

  swivuCheckGrants() {}

  onRecordChange({ value, source, userAction, valid }) {
    if (this.record && userAction && valid) {
      const { name: key } = source;
      if (key === "name") {
        const swivuResourceEditor = this.up("swivuresourceeditorv2");
        if (swivuResourceEditor) {
          swivuResourceEditor.updateEditorTitle(value, this.record);
        }
      }
      if (this.record.isPhantom) {
        this.record[key] = value;

        if (!this.record.tagsId) this.record.tagsId = [];

        // Only append record to store if it was not yet added, because this code will be run twice
        if (this.project.resourceStore.indexOf(this.record) === -1) {
          // See SwivuResourceEditor editRecord function "for WHY"
          this.record.project = null;
          this.project.resourceStore.add(this.record);
        }
      }
    }
  }
}

ResourceEditTabBase.initClass();
